<template>
  <div class="account-subscribes">
    <h2>Настройка уведомлений</h2>

    <div class="settings">
      <ui-checkbox
        v-for="subscription in currentSettings"
        :key="subscription.id"
        v-model="subscription.active"
        class="checkbox"
        :headline="labels[subscription.code] || ''"
        :label="subscription.description"
      />
    </div>

    <ui-button
      class="button"
      wide
      :disabled="settingsIdentical"
      :loading="isLoading"
      text="Сохранить"
      @click="save"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'account-subscribes',

  data() {
    return {
      currentSettings: [],
      isLoading: false,
      labels: {
        SMS: 'SMS рассылка «Акции Клубной программы FUN-CLUB»',
        EMAIL: 'Email рассылка «Акции, скидки и новости FUNDAY и Клубной программы FUN-CLUB»',
        PUSH: 'Push-оповещения на мобильном устройстве'
      }
    }
  },

  computed: {
    ...mapGetters({
      SUBSCRIPTIONS: 'user/subscriptions'
    }),

    settingsIdentical() {
      return JSON.stringify(this.SUBSCRIPTIONS) === JSON.stringify(this.currentSettings);
    }
  },

  created() {
    // чтобы не мутировать данные в сторе и иметь возможность отследить изменения
    this.copySettingsFromAccount();
  },

  methods: {
    ...mapActions({
      SET_SUBSCRIPTIONS: 'user/setSubscriptions'
    }),

    copySettingsFromAccount() {
      this.currentSettings = JSON.parse(JSON.stringify(this.SUBSCRIPTIONS));
    },

    save() {
      this.isLoading = true;

      this.$store.$api.changeSubscriptions(this.currentSettings.map(({ active, code }) => ({ active, code })))
          .then(subs => {
            this.SET_SUBSCRIPTIONS(subs);
            this.copySettingsFromAccount();
          })
          .catch(({ error = {} } = {}) => {
            this.$store.dispatch('notifications/create', {
              title: 'Ошибка!',
              message: error.detail || '',
            });
          })
          .finally(() => {
            this.isLoading = false;
          })
    },
  }
};
</script>

<style lang="scss">
.account-subscribes {
  h2 {
    margin-top: 32px;
  }

  .settings {
    display: flex;
    flex-direction: column;
  }

  .checkbox,
  .button {
    margin-top: 24px;
  }
}

@include breakpoint("tablet") {
  .account-subscribes {
    .button {
      width: 113px;
    }
  }
}

@include breakpoint("desktop") {
  .account-subscribes {
    h2 {
      margin-top: 0;
    }

    .button {
      height: 56px;
      margin-top: 56px;
      font-size: 16px;
    }
  }
}
</style>
